// Page-wide UI state shared between the left list, search toolbar, code table,
// and reference panel. Server data lives in React Query — this store only
// tracks selection + search input (PRD 08 §5 "Screen State Definitions").

import { create } from 'zustand';

// v9: selected ids are number (BIGINT UNSIGNED).
interface DiseaseCodePageState {
  selectedGroupId: number | null;
  selectedCodeId: number | null;
  search: string;

  // Selecting a new group resets the code selection AND clears the search so
  // the right panel always starts fresh (matches prototype `bindGroupEvents`).
  selectGroup: (id: number | null) => void;
  selectCode: (id: number | null) => void;
  setSearch: (q: string) => void;
  reset: () => void;
}

const INITIAL: Pick<DiseaseCodePageState, 'selectedGroupId' | 'selectedCodeId' | 'search'> = {
  selectedGroupId: null,
  selectedCodeId: null,
  search: '',
};

export const useDiseaseCodePageStore = create<DiseaseCodePageState>((set) => ({
  ...INITIAL,
  selectGroup: (id) =>
    set((s) =>
      s.selectedGroupId === id
        ? s
        : { selectedGroupId: id, selectedCodeId: null, search: '' },
    ),
  selectCode: (id) => set({ selectedCodeId: id }),
  setSearch: (q) => set({ search: q }),
  reset: () => set(INITIAL),
}));
